import { observable, computed, asStructure } from "mobx";
import {logger } from "./logger";

function getWindowDimensions() {
    return {
        width: $(window).width(),
        height: $(window).height()
    }
}

export class AppStore {

    @observable language = navigator.language || "en-US";
    @observable pendingRequestCount = 0;

    @observable windowDimensions = {
        width: $(window).width(),
        height: $(window).height()
    };

    logger = logger;

    constructor() {
        $(window).resize(() => {
            try {
                this.windowDimensions = getWindowDimensions();
            } catch (ex) {

            }
        });
    }
    @computed get appIsInSync() {
        return this.pendingRequestCount === 0
    }

    setLanguage(language) {
        this.language = language;
    }

    userId = `temp-${new Date().valueOf()}`;
    FullName = this.userId;
}


// WEBPACK FOOTER //
// ./src/stores/app.ts